import { Component } from '@angular/core';

@Component({
  selector: 'mnc-sdoh-samples',
  template: '<router-outlet></router-outlet>',
  standalone: false
})
export class SamplesComponent {
}
